import apiClient from "@/api/client";

export type SecondaryContractRateType = "hourly" | "monthly";

export interface SecondaryEmploymentContract {
  id: string;
  employee: string;
  employee_name: string;
  kind: "uz";
  kind_display: string;
  effective_from: string;
  effective_to: string | null;
  rate_type: SecondaryContractRateType;
  rate_type_display: string;
  hourly_gross_rate: string;
  company: string | null;
  company_name: string | null;
  company_short_code: string | null;
  note: string;
  contract_scan: string | null;
  contract_scan_url: string | null;
  contract_scan_detail: {
    id: string;
    original_filename: string;
    content_type: string;
    size_bytes: number | null;
    url: string | null;
  } | null;
  created_by: string | null;
  created_by_name: string | null;
  created_at: string;
  updated_at: string;
}

export interface SecondaryContractInput {
  employee: string;
  kind?: "uz";
  effective_from: string;
  effective_to?: string | null;
  rate_type?: SecondaryContractRateType;
  hourly_gross_rate: string;
  company: string;
  note?: string;
}

const wrap = <T,>(res: { data: { data: T } }): T => res.data.data;

export const secondaryContractsApi = {
  list: (employee?: string) =>
    apiClient
      .get<{ data: SecondaryEmploymentContract[] }>("/ceo/secondary-contracts/", {
        params: employee ? { employee } : undefined,
      })
      .then(wrap),

  get: (id: string) =>
    apiClient
      .get<{ data: SecondaryEmploymentContract }>(`/ceo/secondary-contracts/${id}/`)
      .then(wrap),

  create: (payload: SecondaryContractInput) =>
    apiClient
      .post<{ data: SecondaryEmploymentContract }>("/ceo/secondary-contracts/", payload)
      .then(wrap),

  update: (id: string, payload: Partial<SecondaryContractInput>) =>
    apiClient
      .patch<{ data: SecondaryEmploymentContract }>(`/ceo/secondary-contracts/${id}/`, payload)
      .then(wrap),

  remove: (id: string) =>
    apiClient.delete(`/ceo/secondary-contracts/${id}/`).then(() => undefined),

  end: (id: string, effectiveTo: string) =>
    apiClient
      .patch<{ data: SecondaryEmploymentContract }>(`/ceo/secondary-contracts/${id}/`, {
        effective_to: effectiveTo,
      })
      .then(wrap),

  setScan: (id: string, fileId: string | null) =>
    apiClient
      .patch<{ data: SecondaryEmploymentContract }>(`/ceo/secondary-contracts/${id}/`, {
        contract_scan: fileId,
      })
      .then(wrap),
};
